(function () {
  'use strict';
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const controller = new AbortController();
    const signal = controller.signal;
    const chapters = [...root.querySelectorAll('[data-why-chapter]')];
    const links = [...root.querySelectorAll('.wy-nav li a')];
    const choices = [...root.querySelectorAll('[data-formula-choice]')];
    const panels = [...root.querySelectorAll('[data-formula-panel]')];
    const reduce = matchMedia('(prefers-reduced-motion: reduce)');
    let frame = 0;
    function selectFormula(handle, announce) {
      if (!panels.some(panel => panel.dataset.formulaPanel === handle)) return;
      panels.forEach(panel => { panel.hidden = panel.dataset.formulaPanel !== handle; });
      choices.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.formulaChoice === handle)));
      if (announce) root.querySelector('[data-formula-status]').textContent = root.querySelector('#formula-title-' + handle).textContent + ' formula selected.';
      schedule();
    }
    function update() {
      frame = 0;
      const header = document.querySelector('header-component')?.getBoundingClientRect();
      const headerHeight = header && header.top <= 0 && header.bottom > 0 ? header.bottom : 0;
      root.style.setProperty('--wy-header-height', headerHeight + 'px');
      const line = Math.max(headerHeight + 100, innerHeight * .3);
      const rects = chapters.map(chapter => chapter.getBoundingClientRect());
      let active = 0;
      rects.forEach((rect, index) => { if (rect.top <= line) active = index; });
      links.forEach((link, index) => index === active ? link.setAttribute('aria-current', 'step') : link.removeAttribute('aria-current'));
      const travel = rects.at(-1).bottom - rects[0].top - innerHeight * .6;
      root.style.setProperty('--wy-progress', Math.max(0, Math.min(1, (line - rects[0].top) / Math.max(1, travel))));
      if (!reduce.matches) root.style.setProperty('--wy-scene', Math.max(0, Math.min(1, -rects[0].top / rects[0].height)));
      chapters.forEach((chapter, index) => {
        if (rects[index].top < innerHeight * .8 && !chapter.dataset.entered) chapter.dataset.entered = 'true';
      });
    }
    function schedule() { if (!frame) frame = requestAnimationFrame(update); }
    function applyHash() {
      const hash = location.hash.slice(1);
      if (hash.startsWith('formula-')) selectFormula(hash.slice(8), false);
    }
    selectFormula('stay-soft', false);
    applyHash();
    root.querySelector('[data-formula-selector]').hidden = false;
    choices.forEach(button => button.addEventListener('click', () => selectFormula(button.dataset.formulaChoice, true), { signal }));
    window.addEventListener('scroll', schedule, { passive: true, signal });
    window.addEventListener('resize', schedule, { passive: true, signal });
    window.addEventListener('hashchange', applyHash, { signal });
    reduce.addEventListener('change', schedule, { signal });
    const observer = new ResizeObserver(schedule);
    observer.observe(root);
    update();
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(root)) { controller.abort(); observer.disconnect(); cancelAnimationFrame(frame); }
    }, { signal });
  }
  document.querySelectorAll('[data-why-world]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-why-world]').forEach(init));
})();
